import { AutogenModelEdiCarrier, AutogenRowEdiCarrier } from "./autogen/AutogenModelEdiCarrier";

export class ModelEdiCarrier extends AutogenModelEdiCarrier<RowEdiCarrier> {
    constructor() {
        super(RowEdiCarrier);
    }
}

export class RowEdiCarrier extends AutogenRowEdiCarrier {
}